export default "__VITE_ASSET__udKfilId__"